<div
  [ngClass]="[
    'tag',
    'tag-' + color,
    'tag-' + size,
    type !== 'default' ? type : '',
    icon || dsIcon || loader ? 'width-icon-button' : '',
    'tag-width-' + width
  ]"
  [class.soft]="soft"
  [style.width]="width === 'fixed' ? fixedWidth : null"
>
  <ds-loader
    *ngIf="loader && soft && type === 'info'"
    class="icon loader-icon"
    [customSize]="size === 'sm' ? 'var(--size-base-00)' : 'var(--size-base-04)'"
  ></ds-loader>
  <mat-spinner
    *ngIf="loader && !(soft && type === 'info')"
    class="icon loader-spinner"
    [diameter]="size === 'sm' ? 12 : 16"
  ></mat-spinner>
  <mat-icon *ngIf="!loader && icon && !dsIcon" class="material-symbols-outlined icon">{{ icon }}</mat-icon>
  <ds-icon *ngIf="!loader && dsIcon" [icon]="dsIcon" class="icon"></ds-icon>
  <span class="label">{{ label }}</span>
</div>
